var bookshelf = require("../index-extended");

module.exports = bookshelf.model("TableHeader", {
  // !!!: TODO: find a way to avoid table header duplicates ..
  // entityName: "TableHeader",
  // entitySync: true,
  entityUuid: true,

  tableName: "table_header",

  parse(res) {
    if (res.columns) res.columns = JSON.parse(res.columns);
    if (res.settings) res.settings = JSON.parse(res.settings);
    return res;
  },
  format(attrs) {
    if (attrs.columns) attrs.columns = JSON.stringify(attrs.columns);
    if (attrs.settings) attrs.settings = JSON.stringify(attrs.settings);

    delete attrs["$id"];

    return attrs;
  },
});
